export default __webpack_public_path__ + "static/client6-df5d5788df7e42931b028e3d1bd62ea7.jpg";